var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLightning = function SvgLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.902 2c.52 0 .903.52.766 1.012l-1.477 5.113h2.352c.52 0 .93.438.93.957 0 .3-.11.547-.329.738l-7.082 6.016A.763.763 0 0 1 6.57 16c-.52 0-.902-.492-.765-.984L7.28 9.875H4.902A.91.91 0 0 1 4 8.973c0-.274.11-.52.3-.711l7.11-6.07c.137-.11.3-.192.492-.192Zm-.984 2.324-4.95 4.239h2.188c.192 0 .383.109.52.273.11.164.164.383.11.574l-1.231 4.293 5.004-4.265h-2.215a.688.688 0 0 1-.547-.247c-.11-.164-.164-.382-.11-.574l1.231-4.293Z"
  })));
};
export default SvgLightning;